import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './containers/App';
import reportWebVitals from './reportWebVitals';

//importing fonts
import './fonts/NeueMontreal-Light.otf';
import './fonts/NeueMontreal-LightItalic.otf';
import './fonts/NeueMontreal-Regular.otf';
import './fonts/NeueMontreal-RegularItalic.otf';
import './fonts/NeueMontreal-Medium.otf';
import './fonts/NeueMontreal-MediumItalic.otf';
import './fonts/NeueMontreal-Bold.otf';
import './fonts/NeueMontreal-BoldItalic.otf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
